import { FC, useMemo } from "react";
import TableComponent, {
  TableProps,
} from "../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../context/app.context";
import OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableRow from "./types/order-optimizer-cargo-details-hidden-details-center-tables-table-row";
import OrderOptimizerCargoDetailsHiddenDetailsTablesOrdersComponent from "./orders/order-optimizer-cargo-details-hidden-details-center-tables-orders.component";
import orderOptimizerCargoDetailsHiddenDetailsCenterTablesTableHelper from "./order-optimizer-cargo-details-hidden-details-center-tables.helper";
import {
  OrderOptimizerCargoDetailsItemOrders,
  OrderOptimizerCargoDetailsItemStepsLastPoint,
  OrderOptimizerCargoDetailsItemStepsOrders,
} from "../../common/types/order-optimizer-cargo-details-item";

type OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableProps = Pick<
  TableProps,
  "isError" | "isLoading"
> & {
  orders: OrderOptimizerCargoDetailsItemOrders[];
  ordersSteps: OrderOptimizerCargoDetailsItemStepsOrders[];
  lastPoint: OrderOptimizerCargoDetailsItemStepsLastPoint | null;
};

const OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableComponent: FC<
  OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerCargoDetailsHiddenDetailsCenterTablesTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const allStepPoints = useMemo(() => {
    return props.ordersSteps.map((step) => step.points).flat();
  }, [props.ordersSteps]);

  const stepOffsets: number[] = useMemo(() => {
    const offsets: number[] = [];
    let totalOffset = 0;

    props.ordersSteps.forEach((steps) => {
      offsets.push(totalOffset);
      totalOffset += steps.points.length;
    });

    return offsets;
  }, [props.ordersSteps]);

  const createTableRow = (
    order: OrderOptimizerCargoDetailsItemOrders,
    steps: OrderOptimizerCargoDetailsItemStepsOrders,
    stepOffset: number,
    orderIndex: number,
    lastPoint: OrderOptimizerCargoDetailsItemStepsLastPoint | null
  ): OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableRow => {
    return {
      id: uuidService.generate(),
      value: {
        orders: (
          <div className="order_optimizer_cargo_details_hidden_details_center_tables_order">
            <OrderOptimizerCargoDetailsHiddenDetailsTablesOrdersComponent
              allStepPoints={allStepPoints}
              order={order}
              step={steps}
              stepOffset={stepOffset}
              orderIndex={orderIndex}
              lastPoint={lastPoint}
            />
          </div>
        ),
      },
    };
  };

  const rows: OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableRow[] =
    useMemo(() => {
      return props.orders.map((order, orderIndex) =>
        createTableRow(
          order,
          props.ordersSteps[orderIndex],
          stepOffsets[orderIndex],
          orderIndex,
          props.lastPoint
        )
      );
    }, [
      props.lastPoint,
      props.orders,
      props.ordersSteps,
      stepOffsets,
      selectedAppLanguage,
    ]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
      noHeader
    />
  );
};

export default OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableComponent;
